export default "__VITE_ASSET__CzNltAKh__"